"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerSplitCommand = void 0;
const draw_deck_player_action_1 = require("../../actions/draw-deck-player-action");
const player_command_1 = require("./player-command");
const logic_types_1 = require("../../logic-types");
const player_split_action_1 = require("../../actions/player-split-action");
const show_controls_rule_1 = require("../../game-rules/show-controls-rule");
const move_next_player_rule_1 = require("../../game-rules/move-next-player-rule");
const reach_target_score_fork_rule_1 = require("../../game-rules/reach-target-score-fork-rule");
const commit_new_player_action_1 = require("../../preprocessor-actions/commit-new-player-action");
const withdraw_chips_action_1 = require("../../preprocessor-actions/withdraw-chips-action");
const common_rules_1 = require("./common-rules");
class PlayerSplitCommand {
    static isCommand(command) {
        return command instanceof PlayerSplitCommand;
    }
    serializeToString() {
        return player_command_1.CommandTypes.Split;
    }
    validateCommand(context) {
        return context.gameState.isAllowed(logic_types_1.PlayerControls.Split);
    }
    executeCommand(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            context.gameState.setRoundState(logic_types_1.RoundState.Transition, instant);
            const playerId = context.playerManager.getCurrentPlayerId();
            const player = context.playerManager.playerFromId(playerId);
            const nextPlayer = context.playerManager.createNextAvailablePlayer(player.currentBet);
            if (!nextPlayer) {
                throw new Error("Invalid next player");
            }
            const clonedBoard = context.playerManager.board.clone();
            const actions = [
                new player_split_action_1.PlayerSplitAction(clonedBoard, playerId, nextPlayer.playerId),
                new draw_deck_player_action_1.DrawDeckPlayerAction(clonedBoard, playerId),
            ];
            for (const action of actions) {
                action.execute();
            }
            context.playerManager.board.updateFromCopy(clonedBoard);
            [new commit_new_player_action_1.CommitNewPlayerAction(), new withdraw_chips_action_1.WithdrawChipsAction()].forEach((action) => action.execute(context.playerManager, context.gameState, instant));
            yield context.dealProcessor.disclosePendingCards(commandHash, existingDeal);
            for (const action of actions) {
                action.resolve();
                const player = context.playerManager.playerFromId(playerId);
                if (player_split_action_1.PlayerSplitAction.isAction(action)) {
                    context.eventQueue.enqueue({
                        type: "onSplitUpdatePlayerScore",
                        instant,
                        payload: {
                            player: player.clone(),
                            nextPlayer: nextPlayer.clone(),
                            movedCardIndex: action.movedCardIndex,
                        },
                    });
                }
                else if (draw_deck_player_action_1.DrawDeckPlayerAction.isAction(action)) {
                    context.eventQueue.enqueue({
                        type: "onDrawDeckPlayer",
                        instant,
                        payload: { player: player.clone(), cardIndex: action.cardIndex },
                    });
                }
            }
            if (context.logicVersion <= 1) {
                yield this.resultRulesV1(playerId, nextPlayer).execute(commandHash, existingDeal, instant, context);
            }
            else {
                yield this.resultRules(context, playerId).execute(commandHash, existingDeal, instant, context);
            }
            context.analyticsData.numberOfHands++;
        });
    }
    resultRules(context, playerId) {
        return new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, new show_controls_rule_1.ShowControlsRule(), common_rules_1.CommonRules.nextTurnOrEndRules(context, playerId));
    }
    //
    // Legacy
    //
    resultRulesV1(playerId, nextPlayer) {
        return new reach_target_score_fork_rule_1.ReachTargetScoreForkRule(playerId, this.thisPlayerRules(), this.nextPlayerRules(nextPlayer));
    }
    thisPlayerRules() {
        const showControlsRule = new show_controls_rule_1.ShowControlsRule();
        return showControlsRule;
    }
    nextPlayerRules(nextPlayer) {
        if (!nextPlayer) {
            return undefined;
        }
        const moveNextPlayerRules = new move_next_player_rule_1.MoveNextPlayerRule(nextPlayer.playerId);
        const showControlsRule = new show_controls_rule_1.ShowControlsRule();
        moveNextPlayerRules.setNext(showControlsRule);
        return moveNextPlayerRules;
    }
}
exports.PlayerSplitCommand = PlayerSplitCommand;
